import Vue from 'vue';
import Vuex from 'vuex';
import Filters from 'store/modules/filters/filters';
import PlaceStore from 'store/modules/places/places';
import SuggestionStore from 'store/modules/suggestions/suggestions';
import TeamStore from 'store/modules/teams/teams';
import EmployersStore from 'store/modules/employers/employers';
import FilterGrantSuggestionStore from 'store/modules/filterGrantSuggestions/filterGrantSuggestions';

Vue.use(Vuex);

export const Store = new Vuex.Store({
  modules: {
    filters: Filters,
    places: PlaceStore,
    suggestions: SuggestionStore,
    teams: TeamStore,
    employers: EmployersStore,
    filterGrantSuggestions: FilterGrantSuggestionStore
  }
});
